import config from '../../../config';
import Request from '../../Request';

export default function exchangeCode(code, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/stripe/exchange_code`, {code: code}, onSuccess, onFailure);
}